// extracted by mini-css-extract-plugin
export default {"MessageBox":"MessageBoxes_MessageBox__R43q4","YesButton":"MessageBoxes_YesButton__HSda7","NoButton":"MessageBoxes_NoButton__zwyDE"};